import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function Fox(props) {
  return (
    <div className={styles.queryBox}>
      <CloseButton setSelected={props.setSelected} />
      <div className={styles.questions}>
        <p>Hi I'm a Fox, could you help me out mate?</p>
        <p>
          People always stare at me in the city and I have to run away quickly.
          #staringisntcaring #foxyprobs #foxyrunaway Bright car headlights
          lights are always shined in my face late at night #lightsoffplease
        </p>
        <p>
          I keep eating rubbish which I think is food on Bold Street - it cuts
          my throat often #foxfood #DontLitter# stop shining lights at me Please
          write an Incident Report for me, put it in a way that those humans
          could understand, something has to change dosen't it?
        </p>
      </div>
    </div>
  );
}

export default Fox;
